/**
 * O nome da etapa do funil, na língua de quem lê.
 *
 * ── Por que traduzir aqui, e não no motor ─────────────────────────────────
 *
 * O funil vem do motor de CRM, e o funil que ele traz de fábrica é em inglês:
 * `NEW`, `SCREENING`, `MEETING`, `PROPOSAL`, `CUSTOMER` (A01 §4). O `valor` é
 * imutável — é o que fica gravado na oportunidade e o que a integração usa —,
 * então traduzi-lo lá dentro quebraria o vínculo com o que já existe.
 *
 * O que se traduz é o que se LÊ. E só os cinco de fábrica: uma revenda que
 * renomeou a etapa em Configurações já escolheu o nome dela, e sobrepor isso
 * seria apagar a decisão de quem usa. Por isso a regra é: bateu com um dos
 * cinco, mostra o nome em português; não bateu, mostra o que veio.
 *
 * Vale para o `valor` cru (a lista de conversas mostra `MEETING`) e para o
 * `rotulo` do motor (o quadro mostra "Meeting"), porque os dois chegam à tela
 * conforme a rota.
 */

const DE_FABRICA: Record<string, string> = {
  NEW: 'Novo',
  SCREENING: 'Qualificação',
  MEETING: 'Reunião',
  PROPOSAL: 'Proposta',
  CUSTOMER: 'Cliente',
};

/** `MEETING`, `Meeting` e `meeting` são a mesma etapa para quem lê. */
function chave(etapa: string): string {
  return etapa
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_');
}

export function nomeDaEtapa(etapa: string | null | undefined): string {
  if (!etapa) return '';
  return DE_FABRICA[chave(etapa)] ?? etapa;
}
